"use client";

import type { ReactNode } from "react";

export interface UnderlineTabBarProps<T extends string> {
	readonly tabs: readonly T[];
	readonly selected: T;
	readonly onSelect?: (value: T) => void;
	readonly label?: (value: T) => ReactNode;
	readonly className?: string;
}

/**
 * UnderlineTabBar — generic underline segmented control. The active tab shows
 * a 3px accent underline; uses the `.ds-underline-tabs` class from artist-ds.css.
 */
export function UnderlineTabBar<T extends string>({
	tabs,
	selected,
	onSelect,
	label,
	className = "",
}: Readonly<UnderlineTabBarProps<T>>) {
	return (
		<div className={`ds-underline-tabs ${className}`.trim()} role="tablist">
			{tabs.map((value) => (
				<button
					key={value}
					type="button"
					role="tab"
					aria-selected={value === selected}
					className={value === selected ? "selected" : undefined}
					onClick={onSelect !== undefined ? () => onSelect(value) : undefined}
				>
					{label !== undefined ? label(value) : value}
				</button>
			))}
		</div>
	);
}
